module.exports = __webpack_public_path__ + "img/propague.61803e3b.svg";